import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

const ScrollAnimation = ({ children, delay = 0, direction = 'up' }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  // Direction-based initial positions
  const directions = {
    up: { y: 60, x: 0 },
    down: { y: -60, x: 0 },
    left: { y: 0, x: 60 },
    right: { y: 0, x: -60 },
  };

  const initialPosition = directions[direction] || directions.up;

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={{
        visible: {
          opacity: 1,
          y: 0,
          x: 0,
          scale: 1,
          filter: 'blur(0px)',
          transition: {
            type: 'spring',
            stiffness: 80,
            damping: 15,
            delay,
          },
        },
        hidden: {
          opacity: 0,
          y: initialPosition.y,
          x: initialPosition.x,
          scale: 0.95,
          filter: 'blur(4px)',
        },
      }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollAnimation;
